export const SET_USER_DATA = 'SET_USER_DATA';
export const REMOVE_USER_DATA = 'REMOVE_USER_DATA';

export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_CURRENT_ACCOUNT_ID = 'SET_CURRENT_ACCOUNT_ID';
export const SET_USER = 'SET_USER';
export const SET_PAGES = 'SET_PAGES';
export const SET_DOMAINS = 'SET_DOMAINS';
export const SET_TASKS = 'SET_TASKS';
export const SET_SEARCHTERM = 'SET_SEARCHTERM';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js